"use client"

import { RecentReturn } from '@/components/homepage-2026/recent-return'

interface ToolRecentlyViewedRailProps {
  eyebrow?: string
  title?: string
  description?: string
  limit?: number
  className?: string
}

/** Device-local history. Never send stored product IDs to a lookup endpoint. */
export function ToolRecentlyViewedRail({ title = 'Recently viewed', limit = 8 }: ToolRecentlyViewedRailProps) {
  return <RecentReturn title={title} limit={limit} />
}
